import { createElementBlock as e, openBlock as r, createElementVNode as o } from "vue";
function c(t, n) {
  return r(), e("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    o("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18 6L6 18M6 6l12 12"
    })
  ]);
}
export {
  c as default
};
